module.exports = __webpack_public_path__ + "img/project3_3.png.2c1266bd.webp";